import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import { IconShare } from '@/Module/Icon';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';
const LessonDetailShare: FC = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const lesson = useAppSelector(state => state.lessonSection.lessonSectionLesson);
  const [preparedTitle, preparedDescription] = useMemo(() => {
    if (!lesson || !lessonSection) return ['', ''];
    return [`${lessonSection.name} - ${lesson.seoTitle}`, lessonSection.summary];
  }, [lesson, lessonSection]);
  const onClick = () => {
    if (!navigator.share) {
      return;
    }
    navigator.share({
      text: preparedTitle,
      title: preparedDescription,
      url: document.location.href
    }).catch(error => error);
  };
  return <Button variant="contained" color="orangeLight" iconButton onClick={onClick} data-sentry-element="Button" data-sentry-component="LessonDetailShare" data-sentry-source-file="LessonDetailShare.tsx">
      <IconShare data-sentry-element="IconShare" data-sentry-source-file="LessonDetailShare.tsx" />
    </Button>;
};
export default LessonDetailShare;